import { mapGetters } from 'vuex'
import { siteService } from "../../../services/SiteService";
import { userService } from '../../../services/UserService';

import {
    required,
    minLength,
    maxLength,
    email,
} from "vuelidate/lib/validators";
export default {
    name: "FinishOrder",
    props: {
        CurrentOrder: {}
    },
    data() {
        return {
            termsAgreed: false,
            personTermsAgreed: false,
            paymentUrl: '',
            userEmail: '',
            userName: '',
            order : {},
        }
    },
    validations: {
        userName: {
            required,
            minLength: minLength(5),
        },

        userEmail: {
            required,
            email
        },
    },
    computed: {

        ...mapGetters(
            {
                isAuthenticated: 'auth/isAuthenticated',
                userInfo: 'user/profile',
            }),

        isValid() {
            return !this.$v.$error;
        },
        ownerName: function () {
            //return '';
            if (this.order.Owner.OwnerType == 0) // PF
            {
                return this.order.Owner.Person.FirstName + ' ' + this.order.Owner.Person.LastName;
            }
            else {// PJ
                return this.order.Owner.Company.Name;
            }
        },
        selectedOffer: function () {
            //return '';
            return this.order.Offers[0];
        },
        selectedOfferPrice: function () {
            //return '';
            if (this.selectedOffer.DirectSettlement === true) {
                return this.selectedOffer.DirectSettlementPrice;
            }
            else {
                return this.selectedOffer.Price;
            }
        },
        selectedOfferPeriod: function () {
            //return '';
            return this.order.Offers[0].Period;
        },
        selectedOfferInsurer: function () {
            //return '';
            return this.order.Offers[0].Insurer;
        }
    },
    created() {

        this.order = this.CurrentOrder;

        if (this.isAuthenticated) {
            this.userName = this.userInfo.FullName;
            this.userEmail = this.userInfo.UserName;
        }
        else {
            this.userName = this.ownerName;
            this.userEmail = this.order.Owner.Person.Email;
        }
    },
    methods: {
        chkState: function (val) {
            
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid;
        },
        getLogo: function (insurer) {
            return 'img/logos/' + insurer + '-logo.png';
        },

        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },



        createAccountandPay: function (onlinePayment) {
            if (!this.validate()) {
                return;
            }
            if (!this.isAuthenticated) {
                // save user
                var user = {
                    Id: null,
                    UserName: this.userEmail,
                    FullName: this.userName,
                    Email: this.userEmail,
                    EmailConfirmed: false,
                    PhoneNumber: '',
                    IsBlocked: false,
                    Role: 'extuser'
                };
                userService.saveUser(0, user).then((response) => {
                    // set the user on order
                    var setAccountParam = {
                        OrderId: this.order.Id,
                        PAIDOrderId: this.order.PAIDOrderId,
                        UserId: response.data,
                    };
                    // get payment link
                    siteService.setAccountToOrder(setAccountParam).then(() => {
                        debugger
                        var model = this;
                        if (onlinePayment) {

                            // redirect to payment
                            var returnUrl = location.protocol + '//' + window.location.href.split('/')[2] + '/order/' + this.order.Id + '/download';
                            
                            var paymentInfo = {
                                orderNumber: this.order.Id,
                                amount: this.selectedOfferPrice,
                                description: "Polița RCA: " + this.order.Vehicle.PlateNo,
                                returnURL: returnUrl,
                            }
                            siteService.getPaymentUrl(paymentInfo)
                                .then((response) => {
                                    console.log('formUrl ='+ response.data.formUrl);
                                    model.paymentUrl = response.data.formUrl;
                                    // redirect to BT
                                    document.location.href = response.data.formUrl;
                                })
                        }
                        else {
                            model.$router.push('/');
                        }

                    })
                });
            }
            else {
                var setAccountParam = {
                    OrderId: this.order.Id,
                    PAIDOrderId: this.order.PAIDOrderId,
                    UserId: this.userInfo.Id,
                };
                // get payment link
                siteService.setAccountToOrder(setAccountParam).then(() => {
                    var model = this;
                    if (onlinePayment) {
                        // redirect to payment
                        var returnUrl = location.protocol + '//' + window.location.href.split('/')[2] + '/order/' + this.order.Id + '/download';
                        
                        var paymentInfo = {
                            orderNumber: this.order.Id,
                            amount: this.selectedOfferPrice,
                            description: "Polița RCA: " + this.order.Vehicle.PlateNo,
                            returnURL: returnUrl,
                        }
                        siteService.getPaymentUrl(paymentInfo)
                            .then((response) => {
                                console.log(response.data.formUrl);
                                model.paymentUrl = response.data.formUrl;
                                // redirect to BT
                                document.location.href = response.data.formUrl;
                            })
                    }
                    else {
                        model.$router.push('/');
                    }
                })
            }
        }
    }
};
